import { createHash } from 'crypto'

export async function checkGravatarExists(email: string) {
  const hash = createHash('sha256').update(email.toLowerCase().trim()).digest('hex')

  try {
    // The gravatar service will return a 404 error if no gravatar exists, then we can override the default gravatar with the user acronym
    const response = await fetch(`https://www.gravatar.com/avatar/${hash}?d=404`)
    return response.ok
  } catch {
    return false
  }
}
